const selectors = {
  productMedia: document.querySelector("[data-productMedia]"),
};
const generateSrcset = (
  imageSrc,
  widths = [246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426],
) => {
  return widths
    .map((width) => `https:${imageSrc}&width=${width} ${width}w`)
    .join(",");
};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`,
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset,
      )}px`,
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    // console.log('open');
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");

    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
    document.getElementsByTagName("html")[0].classList.add("overflow-x-hidden");
    if (this.hasAttribute("data-scroll-lock")) {
      document
        .getElementsByTagName("html")[0]
        .classList.add("overflow-y-hidden");
    }
  }

  hide() {
    // console.log('close');
    document
      .getElementsByTagName("html")[0]
      .classList.remove("overflow-x-hidden");
    if (this.hasAttribute("data-scroll-lock")) {
      document
        .getElementsByTagName("html")[0]
        .classList.remove("overflow-y-hidden");
    }
    document.body.classList.remove("overflow-hidden");

    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      console.log("modal", modal);
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this),
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active",
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

function replaceUrlParam(url, paramName, paramValue) {
  if (paramValue == null) {
    paramValue = "";
  }
  var pattern = new RegExp("\\b(" + paramName + "=).*?(&|#|$)");
  if (url.search(pattern) >= 0) {
    return url.replace(pattern, "$1" + paramValue + "$2");
  }
  url = url.replace(/[?#]$/, "");
  return (
    url + (url.indexOf("?") > 0 ? "&" : "?") + paramName + "=" + paramValue
  );
}

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    var _this = this;
    var calledOnce = false;
    this.removeEventListener("change", this.onVariantChange);
    this.addEventListener("change", this.onVariantChange);
    // console.log('onload');
    // this.updateMasterId()

    this.onFirstLoad();
    this.updateImgOnload();
    // console.log("onVariantChange-->onVariantChange")
  }

  onFirstLoad() {
    this.updateOptions();
    this.updateMasterId();
    // this.toggleAddButton(true, '', false);
    // this.updatePickupAvailability();
    // this.removeErrorMessage();
    if (this.currentVariant) {
      this.updateMedia(false);
      this.updateURL();
      this.updateShareUrl();
      this.updateMetadata();
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia(true);
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateMetadata();

      if (this.calledOnce) {
        dataLayer.push({
          event: "view_item_v2",
          ecommerce: {
            currency: "USD",
            items: [
              {
                item_id: this.currentVariant.sku,
                item_name: this.currentVariant.name,
                currency: "USD",
                discounted_price:
                  this.currentVariant.compare_at_price >
                  this.currentVariant.price
                    ? "yes"
                    : "no",
                discount:
                  this.currentVariant.compare_at_price >
                  this.currentVariant.price
                    ? (
                        ((this.currentVariant.compare_at_price -
                          this.currentVariant.price) /
                          this.currentVariant.compare_at_price) *
                        100
                      ).toFixed(0)
                    : 0, //discount in percentage
                item_brand:
                  this.currentVariant.type == "Nudeskin"
                    ? "Nudeskin"
                    : "Nudestix",
                item_category: this.currentVariant.type,
                item_variant: this.currentVariant.title,
                price: this.currentVariant.price,
              },
            ],
          },
        });
      } else {
        this.calledOnce = true;
      }
    }

    this.calledOnce = true;
  }
  updateDetailsTab(metaEle) {
    const detailsTabEle = document.querySelector(
      "[data-accordion-title='details']",
    );
    const detailsTabContent = document.querySelector(
      "script[data-accordion-content]",
    );

    if (!detailsTabContent || !detailsTabEle) return;

    const metaDetails = metaEle?.getAttribute("data-meta-details");
    detailsTabEle.innerHTML =
      metaDetails || JSON.parse(detailsTabContent.textContent);
  }
  updateMetadata() {
    var metaEle = document.querySelector(
      `[data-meta-id="${this.currentVariant.id}"]`,
    );
    // console.log('metaEle',metaEle, this.currentVariant);
    if (
      typeof metaEle != "undefined" &&
      metaEle != null &&
      this.dataset.secname != "featureproduct" &&
      this.dataset.secname != "quickview"
    ) {
      if (metaEle.hasAttribute("data-meta-title")) {
        document.querySelector("title").innerText =
          metaEle.getAttribute("data-meta-title");
        document
          .querySelectorAll("[data-main-pro-title]")
          .forEach(
            (x) => (x.innerText = metaEle.getAttribute("data-meta-title")),
          );
        var twitterTitle = document.querySelector('[name="twitter:title"]');
        if (typeof twitterTitle != "undefined" && twitterTitle != null) {
          document
            .querySelector('[name="twitter:title"]')
            .setAttribute(
              "content",
              `${metaEle.getAttribute("data-meta-title")}`,
            );
        }

        var ogTitle = document.querySelector('[property="og:title"]');
        if (typeof ogTitle != "undefined" && ogTitle != null) {
          document
            .querySelector('[property="og:title"]')
            .setAttribute(
              "content",
              `${metaEle.getAttribute("data-meta-title")}`,
            );
        }
      }
      if (metaEle.hasAttribute("data-title")) {
        document.querySelector("title").innerText =
          metaEle.getAttribute("data-title");
      }
      if (metaEle.hasAttribute("data-meta-description")) {
        document
          .querySelectorAll("[data-main-pro-description]")
          .forEach(
            (x) =>
              (x.innerText = metaEle.getAttribute("data-meta-description")),
          );
        var twitterDesc = document.querySelector(
          '[name="twitter:description"]',
        );
        if (typeof twitterDesc != "undefined" && twitterDesc != null) {
          document
            .querySelector('[name="twitter:description"]')
            .setAttribute(
              "content",
              `${metaEle.getAttribute("data-meta-description")}`,
            );
        }

        var ogDesc = document.querySelector('[property="og:description"]');
        if (typeof ogDesc != "undefined" && ogDesc != null) {
          document
            .querySelector('[property="og:description"]')
            .setAttribute(
              "content",
              `${metaEle.getAttribute("data-meta-description")}`,
            );
        }
      }
      if (metaEle.hasAttribute("data-orgmeta-description")) {
        document
          .querySelector('meta[name="description"]')
          .setAttribute(
            "content",
            metaEle.getAttribute("data-orgmeta-description"),
          );
      }
      this.updateDetailsTab(metaEle);

      if (metaEle.hasAttribute("data-meta-ingredient")) {
        var ingreTabEle = document.getElementById("ProductAccordion-ingre");
        if (typeof ingreTabEle != "undefined" && ingreTabEle != null) {
          ingreTabEle.innerHTML = metaEle.getAttribute("data-meta-ingredient");
        }
      }
      if (metaEle.hasAttribute("data-allure-badge")) {
        let allureBadge = document.querySelector(".allure-badge");
        if (allureBadge) {
          allureBadge.style.display =
            metaEle.getAttribute("data-allure-badge") == "true"
              ? "block"
              : "none";
        }
      }
      if (metaEle.hasAttribute("data-allure-badge2")) {
        let allureBadge2 = document.querySelector(".allure-badge2");
        if (allureBadge2) {
          const allureBadge2Value = metaEle.getAttribute("data-allure-badge2");
          if (allureBadge2.querySelector("img"))
            allureBadge2.querySelector("img").src = allureBadge2Value;
          allureBadge2.style.display =
            allureBadge2Value !== "false" ? "block" : "none";
        }
      }
      if (metaEle.hasAttribute("data-social-proof-badge")) {
        const socialProofBadge = document.querySelector(".social-proof-badge");

        if (socialProofBadge) {
          socialProofBadge.style.display =
            metaEle.getAttribute("data-social-proof-badge") == "true"
              ? "block"
              : "none";
          const badgeContent = socialProofBadge.querySelector(
            ".social-proof-badge-content",
          );
          if (badgeContent) {
            badgeContent.textContent = metaEle.getAttribute(
              "data-social-proof-badge-title",
            );
            badgeContent.style.background = metaEle.getAttribute(
              "data-social-proof-badge-bg",
            );
            badgeContent.style.color = metaEle.getAttribute(
              "data-social-proof-badge-color",
            );
          }
        }
      }
    } else if (
      this.dataset.secname == "featureproduct" &&
      document.querySelector(
        `#CardVariant-${this.dataset.section}-${this.dataset.proid}`,
      )
    ) {
      document.querySelector(
        `#CardVariant-${this.dataset.section}-${this.dataset.proid}`,
      ).innerText = `Shade: ${this.currentVariant.option1}`;
      if (
        typeof metaEle != "undefined" &&
        metaEle != null &&
        (metaEle.hasAttribute("data-allure-badge") ||
          metaEle.hasAttribute("data-allure-badge2")) &&
        document.querySelector(
          `#CardVariant-${this.dataset.section}-${this.dataset.proid}`,
        )
      ) {
        document.querySelector(
          `#Allure-${this.dataset.section}-${this.dataset.proid}`,
        ).style.display =
          metaEle.getAttribute("data-allure-badge") == "true"
            ? "block"
            : "none";

        if (metaEle.hasAttribute("data-allure-badge2")) {
          let allureBadge2 = document.querySelector(
            `#Allure2-${this.dataset.section}-${this.dataset.proid}`,
          );
          if (allureBadge2) {
            const allureBadge2Value =
              metaEle.getAttribute("data-allure-badge2");
            if (allureBadge2.querySelector("img"))
              allureBadge2.querySelector("img").src = allureBadge2Value;
            allureBadge2.style.display =
              allureBadge2Value !== "false" ? "block" : "none";
          }
        }

        if (
          document.querySelector(
            `#product-tag-${this.dataset.section}-${this.dataset.proid}`,
          )
        ) {
          document.querySelector(
            `#product-tag-${this.dataset.section}-${this.dataset.proid}`,
          ).style.display =
            metaEle.getAttribute("data-allure-badge") == "true" ||
            metaEle.getAttribute("data-allure-badge2") !== "false"
              ? "none"
              : "flex";
        }
      }
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });

    if (!this.currentVariant) {
      this.currentVariant = this.getVariantData().find((variant) => {
        let matchedOptions = variant.options.filter((option) => {
          return this.options.includes(option);
        });
        return matchedOptions.length > 0;
      });
    }
  }

  updateMedia(is_loaded) {
    var _this = this;

    var parentEle = this.closest(".product-parent");
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    if (typeof parentEle != "undefined" && parentEle != null) {
      var colorNameEle = parentEle.querySelector("[data-selected-option]");
      if (typeof colorNameEle != "undefined" && colorNameEle != null) {
        colorNameEle.innerHTML = parentEle.querySelector(
          "input[data-main-color]:checked",
        ).value;
      }
    }

    // console.log('dllllll',this.closest('section'));
    if (
      this.closest("section") != null &&
      this.closest("section") != undefined
    ) {
      if (this.closest("section").getAttribute("template") == "product") {
        var breadelement = document.querySelector("[data-bread-color]");
        if (typeof breadelement != "undefined" && breadelement != null) {
          breadelement.innerText = parentEle.querySelector(
            "input[data-main-color]:checked",
          ).value;
        }
      }
    }

    if (this.dataset.secname == "featureproduct") {
      document
        .querySelector(
          `[data-feature-img="${this.dataset.section}-${this.dataset.proid}"] img`,
        )
        ?.setAttribute("src", this.currentVariant.featured_image.src);
      return;
    }
    if (this.dataset.secname == "quickview") {
      let metaEle = document.querySelector(
        `[data-meta-id="${this.currentVariant.id}"]`,
      );
      let swatchInputElement = document.querySelector(
        `input[data-qv-swatch-index]`,
      );

      if (metaEle.hasAttribute("data-allure-badge")) {
        let allureBadge = document.querySelector(".allure-badge");
        if (allureBadge) {
          allureBadge.style.display =
            metaEle.getAttribute("data-allure-badge") == "true"
              ? "block"
              : "none";
        }
      }
      if (metaEle.hasAttribute("data-allure-badge2")) {
        let allureBadge2 = document.querySelector(".allure-badge2");
        if (allureBadge2) {
          const allureBadge2Value = metaEle.getAttribute("data-allure-badge2");
          if (allureBadge2.querySelector("img"))
            allureBadge2.querySelector("img").src = allureBadge2Value;
          allureBadge2.style.display =
            allureBadge2Value !== "false" ? "block" : "none";
        }
      }
      // This condition is used to set an active class in the initial swatch.
      if (
        swatchInputElement?.getAttribute("data-qv-swatch-index") ==
          metaEle?.getAttribute("data-qv-index") ||
        swatchInputElement?.value?.toLowerCase() ==
          this.currentVariant.option1?.toLowerCase()
      ) {
        document.querySelector("[data-qv-swatch]")?.classList.add("active");
      }

      if (metaEle.hasAttribute("data-meta-title")) {
        document
          .querySelectorAll("[main-quick-title]")
          .forEach(
            (x) => (x.innerText = metaEle.getAttribute("data-meta-title")),
          );
      }
      let productPageMainImageSlider = new Swiper(".qv-pdp-carousel", {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 10,
        grabCursor: true,
        navigation: {
          nextEl: ".qv-swiper-button-next",
          prevEl: ".qv-swiper-button-prev",
        },
      });
      const product_media = document.querySelector(
        "[data-quick-productMedia]",
      ).innerHTML;
      const mediaJSON = JSON.parse(product_media);
      const colorMedia = [];
      const colorName = this.currentVariant.option1.toLowerCase();
      mediaJSON.forEach((media) => {
        let mediaAlt = media.alt;
        if (mediaAlt) mediaAlt = mediaAlt.toLowerCase();
        if (mediaAlt != null) {
          if (
            mediaAlt == colorName ||
            mediaAlt.includes(colorName) ||
            mediaAlt.includes(colorName.replaceAll(" ", ""))
          )
            colorMedia.push(media);
        }
      });
      if (colorMedia.length > 0) {
        productPageMainImageSlider.removeAllSlides();
      }
      colorMedia.forEach((i) => {
        productPageMainImageSlider.appendSlide(` <div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="{{ image.id }}" role="treeitem">
                    <img class="lazy drift-trigger" 
                        src="https:${i.preview_image.src}&width=1206" 
                        srcset="${generateSrcset(i.preview_image.src)}"
                        sizes="(min-width: 1200px) 715px, (min-width: 990px) calc(65.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)"
                        loading="lazy drift-trigger"
                        data-variant-title="${i.alt}"
                        alt="${i.alt}"
                        width="${i.width}"
                        height="${i.width}"
                        data-zoom="https:${i.preview_image.src}&width=1206"
                    >
                    </div>`);
      });
      productPageMainImageSlider.update();
    }

    if (this.dataset.secname == "mainproduct") {
      var mainSlider =
        this.closest(".product-parent").getElementsByClassName("pdp-carousel");
      if (typeof productPageThumbnailImageSlider != "undefined") {
        const mediaJSON = JSON.parse(selectors.productMedia.innerHTML);
        const colorMedia = [];
        const colorName = this.currentVariant.option1.toLowerCase();
        mediaJSON.forEach((media) => {
          let mediaAlt = media.alt;
          if (mediaAlt) mediaAlt = mediaAlt.toLowerCase();
          if (mediaAlt != null) {
            if (
              mediaAlt == colorName ||
              mediaAlt.includes(colorName) ||
              mediaAlt.includes(colorName.replaceAll(" ", ""))
            )
              colorMedia.push(media);
          }
        });
        if (colorMedia.length > 0) {
          productPageThumbnailImageSlider.removeAllSlides();
          productPageMainImageSlider.removeAllSlides();
          productPageDialogThumbImageSlider.removeAllSlides();
          productPageDialogImageSlider.removeAllSlides();

          productPageDialogThumbImageSlider.update();
          productPageDialogImageSlider.update();
        }
        colorMedia.forEach((i) => {
          productPageThumbnailImageSlider.appendSlide(`<div class="swiper-slide product-thumb--image" data-mediaID="${i.id}" role="treeitem">
                        <img class="img-fluid lazy"
                            src="https:${i.preview_image.src}&width=250"
                            srcset="https:${i.preview_image.src}&width=250"
                            sizes="250px"  
                            loading="lazy"
                            width="${i.width}"
                            height="${i.width}" 
                            alt="${i.alt}"/>
                        </div>`);

          productPageMainImageSlider.appendSlide(` <div role="treeitem" class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="{{ image.id }}">
                        <img class="lazy drift-trigger" 
                            srcset="${generateSrcset(i.preview_image.src)}"
                            sizes="(min-width: 1200px) 715px, (min-width: 990px) calc(65.0vw - 10rem), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw / 1 - 4rem)"
                            src="https:${i.preview_image.src}&width=1206" 
                            loading="lazy drift-trigger"
                            data-variant-title="${i.alt}"
                            alt="${i.alt}"
                            width="${i.width}"
                            height="${i.width}"
                            data-zoom="https:${i.preview_image.src}&width=1206"
                        >
                        </div>`);
          if (is_loaded) {
            productPageDialogThumbImageSlider.appendSlide(`<div class="swiper-slide product-thumb--image" data-mediaID="${i.id}" role="treeitem">
                        <img class="img-fluid"
                            src="https:${i.preview_image.src}&width=250px"
                            srcset="https:${i.preview_image.src}&width=250px"
                            sizes="250px"  
                            loading="lazy"
                            width="${i.width}"
                            height="${i.width}" 
                            alt="${i.alt}"/>
                        </div>`);

            productPageDialogImageSlider.appendSlide(` <div class="swiper-slide carousel-cell d-flex align-items-center product--media" data-mediaID="{{ image.id }}" role="treeitem">
                            <img class="img-fluid" srcset="https:${i.preview_image.src}"
                                src="https:${i.preview_image.src}" loading="lazy"
                                data-variant-title="${i.alt}"
                                alt="${i.alt}"
                                width="${i.width}"
                                height="${i.width}"
                            >
                            </div>`);
          }
        });
        productPageMainImageSlider.update();
        productPageThumbnailImageSlider.update();
        productPageDialogThumbImageSlider.update();
        productPageDialogImageSlider.update();
      }

      if (typeof mainSlider != "undefined" && mainSlider != null) {
        const swiper2 = new Swiper(".pdp-carousel", {
          loop: false,
          observer: true,
          observeParents: true,
          slidesPerView: 1,
          spaceBetween: 10,
          grabCursor: true,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          thumbs: {
            swiper: swiper,
          },
        });

        var thumbImage = this.closest(".product-parent").querySelector(
          "input[data-main-color]:checked",
        ).value;
        if (typeof thumbImage != "undefined" && thumbImage != null) {
          let finalAltText = thumbImage
            .replace(/[!@#$%^&*]/, "")
            .replace(/\s/g, "")
            .toLowerCase();
          let getThumbImage = this.closest(".product-parent").querySelectorAll(
            `[data-thumb-alt="${finalAltText}"]`,
          );
          // console.log('thumbImage', getThumbImage);
          if (getThumbImage.length > 0) {
            var getIndex = getThumbImage[0].getAttribute("data-thumb-count");
            // console.log('getIndex',getIndex);
            if (typeof getIndex != "undefined" && getIndex != null) {
              if (document.querySelector("[data-templateName]") != null) {
                if (
                  document
                    .querySelector("[data-templateName]")
                    .innerText.includes("product.quick")
                ) {
                  swiper2.slideTo(Number(getIndex));
                }
              }
              // if(typeof(drift) != "undefined"){
              //     drift.destroy();
              //     loadDrift();
              //     loadPinchZoom();
              // }
            }
          }
        }
      }
    }

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`,
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true,
      ),
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    modalContent.prepend(newMediaModal);
  }

  updateImgOnload() {
    var getparent = this.closest(".product-parent");
    if (typeof getparent != "undefined" && getparent != null) {
      var mainSlider = getparent.getElementsByClassName("pdp-carousel");
      var swatchelement = getparent.querySelector(
        "input[data-main-color]:checked",
      );

      if (
        typeof mainSlider != "undefined" &&
        mainSlider != null &&
        typeof swatchelement != "undefined" &&
        swatchelement != null
      ) {
        const swiper2 = new Swiper(".pdp-carousel", {
          loop: false,
          observer: true,
          observeParents: true,
          slidesPerView: 1,
          spaceBetween: 10,
          grabCursor: true,
          // effect: 'fade',
          // fadeEffect: {
          //   crossFade: true
          // },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          thumbs: {
            swiper: swiper,
          },
        });

        // const swiper = new Swiper(".product-thumbnails", {
        //     direction: "horizontal",
        //     loop: false,
        //     spaceBetween: 10,
        //     slidesPerView: "auto",
        //     grabCursor: true,
        //     slideToClickedSlide: true,
        //     allowTouchMove: true
        // });
        var thumbImage = this.closest(".product-parent").querySelector(
          "input[data-main-color]:checked",
        ).value;
        if (typeof thumbImage != "undefined" && thumbImage != null) {
          let finalAltText = thumbImage
            .replace(/[!@#$%^&*]/, "")
            .replace(/\s/g, "")
            .toLowerCase();
          let getThumbImage = this.closest(".product-parent").querySelectorAll(
            `[data-thumb-alt="${finalAltText}"]`,
          );
          if (getThumbImage.length > 0) {
            var getIndex = getThumbImage[0].getAttribute("data-thumb-count");
            if (typeof getIndex != "undefined" && getIndex != null) {
              swiper2.slideTo(Number(getIndex));
            }
          }
        }
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    const newurl = replaceUrlParam(
      window.location.href,
      "variant",
      this.currentVariant.id,
    );
    window.history.replaceState({}, "", newurl);

    var canonicalElement = document.querySelector('[rel="canonical"]');
    var ogURLEle = document.querySelector('[property="og:url"]');
    if (typeof canonicalElement != "undefined" && canonicalElement != null) {
      document
        .querySelector('[rel="canonical"]')
        .setAttribute(
          "href",
          `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
        );
    }
    if (typeof ogURLEle != "undefined" && ogURLEle != null) {
      document
        .querySelector('[property="og:url"]')
        .setAttribute(
          "content",
          `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
        );
    }
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    var productForms = "";
    if (this.dataset.secname == "featureproduct") {
      productForms = document.querySelectorAll(
        `[id^="product-form-${this.dataset.section}-${this.dataset.proid}"], #product-form-installment-${this.dataset.section}`,
      );
    } else {
      productForms = document.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
      );
    }
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.setAttribute("varName", this.currentVariant.name);
      input.setAttribute("varSku", this.currentVariant.sku);
      input.varName = this.currentVariant.name;
      input.varSku = this.currentVariant.sku;
      // console.log('hereeeeeee',this.currentVariant);
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
    if (typeof updateCompareVariant === "function") {
      updateCompareVariant(this.currentVariant.id, this.dataset.proid);
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    // console.log("aaaaa***************",productForm.handleErrorMessage())
    // if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    if (this.dataset.secname == "featureproduct") {
      var url = `${this.dataset.url}?variant=${this.currentVariant.id}`;
    } else {
      var url = `${this.dataset.url}?variant=${this.currentVariant.id}`;
    }
    fetch(url)
      .then((response) => {
        // console.log("res.json::",JSON.stringify(response.json()))
        return response.text();
      })
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections

        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");

        const sourceAvailableValue = html.querySelector("[data-format-radio]");

        if (sourceAvailableValue) {
          const targetElement = document.querySelector("[data-format-radio]");
          if (targetElement) {
            targetElement.innerHTML = sourceAvailableValue.innerHTML;
          }
        }

        if (this.dataset.secname == "featureproduct") {
          // var sectionPreText = `template--${this.dataset.proid}__main`;
          const destination1 = document.getElementById(
            `price-${this.dataset.section}-${this.dataset.proid}`,
          );
          const source1 = html.querySelector(`[data-main-pro-price]`);
          if (source1 && destination1)
            destination1.innerHTML = source1.innerHTML;
          // const availVal = source1.querySelectorAll("[data-value-available]");
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut,
          );
          return;
        }
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut,
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    var productForm = "";
    if (this.dataset.secname == "featureproduct") {
      productForm = document.querySelector(
        `[id^="product-form-${this.dataset.section}-${this.dataset.proid}"]`,
      );
      // productForm = document.getElementById(`product-form-${this.dataset.section}-${this.dataset.proid}`);
      var quickBtn = document.querySelector(
        `[data-quickbtn=quickbtn-${this.dataset.section}-${this.dataset.proid}]`,
      );
      if (disable) {
        quickBtn?.classList?.add("hidden");
      } else {
        quickBtn?.classList?.remove("hidden");
      }
    } else {
      productForm = document.getElementById(
        `product-form-${this.dataset.section}`,
      );
    }
    // console.log('productform: ', productForm);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');

    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) {
        addButtonText.textContent = text;
        addButton.classList.add("btn-skin-soldout");
        addButton.classList.remove("btn-skin");
      }
    } else {
      addButton.removeAttribute("disabled");
      if (
        addButton.hasAttribute("data-bundle-add") ||
        addButton.hasAttribute("data-bundle-add-quick")
      ) {
        addButtonText.textContent = "ADD TO PALETTE";
      } else {
        addButtonText.textContent = "ADD TO BAG";
      }

      addButton.classList.add("btn-skin");
      addButton.classList.remove("hidden");
      addButton.classList.remove("btn-skin-soldout");
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}-${this.dataset.proid}-${this.dataset.proid}-submit`,
    );
    // const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));

    this.options = fieldsets.map((fieldset) => {
      const inputs = Array.from(fieldset.querySelectorAll("input"));
      inputs.forEach((radio) =>
        radio.closest(".swatch-box").classList.remove("active"),
      );

      const selectedInput = inputs.find((radio) => radio.checked);
      if (selectedInput) {
        selectedInput.closest(".swatch-box").classList.add("active");
      }

      return selectedInput?.value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

document.querySelectorAll(".product-card-wrapper a").forEach(function (target) {
  target.addEventListener("click", function (event) {
    var targetClose = event.currentTarget.closest(".product-card-wrapper");

    dataLayer.push({
      event: "select_item",
      ecommerce: {
        item_list_name: `product/${targetClose.getAttribute("data-vendor")}`,
        items: [
          {
            item_id: `${targetClose.getAttribute("data-sku")}`,
            item_name: `${targetClose
              .getAttribute("data-itemTitle")
              .toLowerCase()}`,
            currency: "USD",
            index: `${targetClose.getAttribute("data-index")}`,
            discounted_price: `{% if product.compare_at_price > product.price %}yes{% else %}no{% endif %}`,
            discount: `{% product.compare_at_price > product.price %}{{ product.compare_at_price | minus: product.price | times: 100.0 | divided_by: product.compare_at_price | money_without_currency | remove: '.0' | remove: ',' }}{% else %}0{% endif %}`,
            item_brand: `${targetClose
              .getAttribute("data-vendor")
              .replace(" US", "")}`,
            item_category: `${targetClose.getAttribute("data-type")}`,
            item_variant: `${targetClose.getAttribute("data-variantTitle")}`,
            item_list_name: `product/${targetClose.getAttribute(
              "data-vendor",
            )}`,
            price: `${targetClose.getAttribute("data-price")}`,
          },
        ],
      },
    });
  });
});

// if (document.querySelector('[data-trigger-promotion]') != null) {
// document.querySelectorAll('[data-trigger-promotion]').forEach(function(target) {
//   target.addEventListener("click", function(event) {
//     dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object
//     dataLayer.push({
//         'event': 'view_promotion',
//         'eventCategory': 'ecommerce',
//         'eventAction': 'promotion impression',
//         'eventLabel': 'black-friday-2022',
//         'promotion_name': 'black-friday-2022',
//         'promotion_id': 'P_12345',
//         'creative_name': 'carroussel_banner_970x250',
//         'creative_slot': '1',
//           'ecommerce': {
//            'promoView': {
//               'promotions': [
//               {
//                 'id': '12345',
//                 'name': 'black-friday-2022',
//                 'creative': 'carroussel_banner_970x250',
//                 'position': '1'
//               }]
//             }
//           }
//     });
//   });
// });
// }

if (document.querySelector(".list-social__link") != null) {
  document.querySelectorAll(".list-social__link").forEach(function (target) {
    target.addEventListener("click", function (event) {
      dataLayer.push({
        event: "socialInt",
        socialNetwork: event.currentTarget.getAttribute("data-name"),
        socialAction: "share",
        socialTarget: event.currentTarget.getAttribute("href"),
      });
    });
  });
}

setTimeout(function () {
  if (document.querySelector("#Subscribe") != null) {
    document
      .querySelector("#Subscribe")
      .addEventListener("click", function (event) {
        var validRegex =
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (
          document.querySelector("#NewsletterForm--footer").value != "" &&
          document
            .querySelector("#NewsletterForm--footer")
            .value.match(validRegex) != null
        ) {
          dataLayer.push({
            event: "email_signup_validated",
            eventCategory: "form",
            eventAction: "email sign-up validated",
            eventLabel: window.location.href,
          });
        }
      });
  }

  if (document.querySelector("[data-logout-click]") != null) {
    document
      .querySelector("[data-logout-click]")
      .addEventListener("click", function (event) {
        dataLayer.push({
          event: "logout",
          eventCategory: "account",
          eventAction: "logout",
          eventLabel: window.location.href,
        });
      });
  }
}, 3000);

setTimeout(function () {
  if (document.querySelector('[aria-label="ADD TO WISHLIST"]') != null) {
    document
      .querySelectorAll('[aria-label="ADD TO WISHLIST"]')
      .forEach(function (target) {
        target.addEventListener("click", function (event) {
          const labelName = event.currentTarget.getAttribute("aria-label");
          if (labelName == "ADD TO WISHLIST") {
            const parentnode = event.currentTarget.parentNode.parentNode;
            const productname = parentnode.getAttribute("data-wlh-name");
            const productsku = parentnode.getAttribute("data-wlh-view");
            // console.log(productname);
            dataLayer.push({
              event: "add_to_wishlist",
              eventCategory: "engagement",
              eventAction: "add to wishlist",
              eventLabel: `${productsku}::${productname.toLowerCase()}`,
              product_sku: `${productsku}`,
              product_name: `${productname.toLowerCase()}`,
            });
          }
        });
      });
  }
}, 5000);
